// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import store from './store/index';
import {ClientTable} from 'vue-tables-2';
import VueSweetalert2 from 'vue-sweetalert2';
import IdleVue from "idle-vue";
import 'sweetalert2/dist/sweetalert2.min.css';
 
Vue.use(VueSweetalert2);
Vue.use(ClientTable);

Axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('jwt');
  config.headers.Authorization =  `Bearer ${token}`;
  
  return config;
});

Vue.prototype.$http = Axios;
Vue.use(BootstrapVue);

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 100000,
  startAtIdle: false
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})
